
  import createMeisterIcons from '../src/createMeisterIcons';

  const ArrowBlockUp = createMeisterIcons("arrow-block-up", [["path",{"fill":"currentColor","d":"M12 4.185 6.867 13.1h3.283V20h3.6v-6.9h3.383zm1.159-.994c-.483-.921-1.835-.921-2.318 0L5.14 13.095l-.01.02a1.06 1.06 0 0 0-.012.945c.168.337.507.54.883.54h2.65v5.55c0 .394.19.725.407.943.218.218.55.407.943.407h3.9c.394 0 .725-.19.943-.407a1.35 1.35 0 0 0 .407-.943V14.6H18a.98.98 0 0 0 .883-.54c.16-.318.126-.669-.012-.945l-.01-.02z","key":"b42b29ff95205dbb49629e8959b8a8e8526b1300","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default ArrowBlockUp
  